import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CALENDAR_SELECT } from '../models/Calendar';
import {
    RangeCustom,
    RangeBegin,
    PrincipalData,
    GroupsRepartitionData,
    AgeGenderData,
    VisitsRepartitionData,
    TimePassedInStoreData,
} from '@app/models/';

import { LanguageService } from '@app/services/language.service';
import { EntryPassageData } from '@app/models/Counting/EntryPassage';

@Injectable({ providedIn: 'root' })
export class CountingService {
    private get lang(): string {
        return this.$languageService.getCurrentLang();
    }

    constructor(
        private http: HttpClient,
        private $languageService: LanguageService
    ) {}

    public getPrincipalDataCustom(
        businessId: number,
        format: CALENDAR_SELECT,
        range: RangeCustom
    ) {
        return this.http.get<PrincipalData>(
            `${environment.backendDomain}/appmobile/counting/localBusiness/${businessId}/principalData?format=custom&range=${format}&begin=${range.begin}&end=${range.end}&beginVs=${range.beginVs}&endVs=${range.endVs}&lang=${this.lang}`
        );
    }

    public getVisitsRepartitionDataCustom(
        businessId: number,
        range: RangeCustom
    ) {
        return this.http.get<PrincipalData>(
            `${environment.backendDomain}/appmobile/counting/localBusiness/${businessId}/visitsRepartitionData?format=custom&begin=${range.begin}&end=${range.end}&beginVs=${range.beginVs}&endVs=${range.endVs}&lang=${this.lang}`
        );
    }

    public getGroupsRepartitionDataCustom(
        businessId: number,
        range: RangeCustom
    ) {
        return this.http.get<PrincipalData>(
            `${environment.backendDomain}/appmobile/counting/localBusiness/${businessId}/groupsRepartitionData?format=custom&begin=${range.begin}&end=${range.end}&beginVs=${range.beginVs}&endVs=${range.endVs}&lang=${this.lang}`
        );
    }

    public getPrincipalData(
        businessId: number,
        format: CALENDAR_SELECT,
        range: RangeBegin
    ) {
        return this.http.get<PrincipalData>(
            `${environment.backendDomain}/appmobile/counting/localBusiness/${businessId}/principalData?format=${format}&begin=${range.begin}&beginVs=${range.beginVs}&lang=${this.lang}`
        );
    }

    public getVisitsRepartitionData(
        businessId: number,
        format: CALENDAR_SELECT,
        range: RangeBegin
    ) {
        return this.http.get<VisitsRepartitionData>(
            `${environment.backendDomain}/appmobile/counting/localBusiness/${businessId}/visitsRepartitionData?format=${format}&begin=${range.begin}&beginVs=${range.beginVs}&lang=${this.lang}`
        );
    }

    public getAgeGenderData(
        businessId: number,
        format: CALENDAR_SELECT,
        range: RangeCustom
    ) {
        return this.http.get<AgeGenderData>(
            `${environment.backendDomain}/appmobile/counting/localBusiness/${businessId}/ageGenderData?format=${format}&begin=${range.begin}&end=${range.end}&beginVs=${range.beginVs}&endVs=${range.endVs}&lang=${this.lang}`
        );
    }

    public getGroupsRepartitionData(
        businessId: number,
        format: CALENDAR_SELECT,
        range: RangeBegin
    ) {
        return this.http.get<GroupsRepartitionData>(
            `${environment.backendDomain}/appmobile/counting/localBusiness/${businessId}/groupsRepartitionData?format=${format}&begin=${range.begin}&beginVs=${range.beginVs}&lang=${this.lang}`
        );
    }

    public getEntryPassageData(
        businessId: number,
        format: CALENDAR_SELECT,
        range: RangeBegin
    ) {
        // TODO: route API pas encore prête, on lit un JSON de fake data en attendant.
        // Une fois la route dispo côté back, décommenter le bloc ci-dessous
        // et supprimer l'appel au fichier local.
        // return this.http.get<EntryPassageData>('/assets/fakeDataEntries.json');

        return this.http.get<EntryPassageData>(
            `${environment.backendDomain}/appmobile/counting/localBusiness/${businessId}/entryPassageData?format=${format}&begin=${range.begin}&beginVs=${range.beginVs}&lang=${this.lang}`
        );
    }

    // public getTimePassedInStoreData(
    //     businessId: number,
    //     format: CALENDAR_SELECT,
    //     range: RangeBegin
    // ) {
    //     return this.http.get<TimePassedInStoreData>(
    //         `${environment.backendDomain}/appmobile/counting/localBusiness/${businessId}/timePassedInStoreData?format=${format}&begin=${range.begin}&beginVs=${range.beginVs}&lang=${this.lang}`
    //     );
    // }
}
